import React, { createContext, useReducer } from 'react'
import jobAlertReducer from './reducer'

type TJobAlert = {
    job_alert_id: number
    user_email: string
    keyword: string
    job_level_id: number
    location: number[]
    industry: number[]
    salary_min: number
    period_type_id: number
    create_date: string
    view_result_en: string
    view_result_vi: string
    notification_by: number
    job_level: number[]
    status: number
    job_function: {
        parentId: number
        childrenIds: number[]
    }[]
}

export type TJobAlertState = {
    first: boolean
    loading: boolean
    error: string
    data: TJobAlert[]
}

const initJobAlertState = {
    first: true,
    loading: true,
    error: '',
    data: []
}

const JobAlertContext = createContext<{
    state: TJobAlertState
    dispatch: any
}>({
    state: initJobAlertState,
    dispatch: () => null
})

const JobAlertProvider = ({ children }) => {
    const [state, dispatch] = useReducer(jobAlertReducer, initJobAlertState)

    return <JobAlertContext.Provider value={{ state, dispatch }}>{children}</JobAlertContext.Provider>
}

export { JobAlertProvider, JobAlertContext }
